module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x640-836906b3f845df043005b93bdebc44d0.webp";